/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
import styles from "./styles";

/**
 * Background Render JSX
 */
const BackgroundRender = props => {
  let { className, condition, background, children } = props;

  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.root}>
      <div
        className={className || classes.default}
        style={
          condition === undefined || condition
            ? {
                backgroundImage: `url(${background})`
              }
            : null
        }
      />
      {children}
    </div>
  );
};

export default BackgroundRender;
